import { render, staticRenderFns } from "./Chevron2.vue?vue&type=template&id=084dc039&scoped=true"
import script from "./Chevron2.vue?vue&type=script&lang=js"
export * from "./Chevron2.vue?vue&type=script&lang=js"
import style0 from "./Chevron2.vue?vue&type=style&index=0&id=084dc039&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084dc039",
  null
  
)

export default component.exports